import { MotionConfig } from 'framer-motion'

import { AppMotionProviderProps } from './types'

const APPLE_STANDARD_EASING: [number, number, number, number] = [
  0.32, 0.72, 0, 1,
]
const STANDARD_DURATION_SECONDS = 0.32

/**
 * Sets the app-wide Framer Motion defaults so individual `motion.*`
 * components don't have to repeat duration + easing on every transition.
 * Mirrors the `durations.standard` + `easings.appleStandard` tokens defined
 * in `panda.config.ts`.
 *
 * @param {AppMotionProviderProps} props
 * @returns {JSX.Element}
 */
const AppMotionProvider = ({
  children,
}: AppMotionProviderProps): JSX.Element => {
  return (
    <MotionConfig
      transition={{
        duration: STANDARD_DURATION_SECONDS,
        ease: APPLE_STANDARD_EASING,
      }}
    >
      {children}
    </MotionConfig>
  )
}

export default AppMotionProvider
